"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compilationHistoryApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const getLatests = (caller) => ({ accountId, sortBy, order = 'DESC', ...filters }) => {
    return caller(`/accounts/${accountId}/compilation-history`).get({
        ...(sortBy ? { [`_order[${sortBy}]`]: order } : {}),
        ...filters,
    });
};
const addLatests = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/compilation-history`).put(payload);
};
exports.compilationHistoryApi = (0, createApi_1.createAPIFactory)({
    getLatests,
    addLatests,
});
//# sourceMappingURL=api.js.map